import { createSlice } from '@reduxjs/toolkit';


const initialState = {
	requestFilter:{
        year:'',
        month:'',
		query:'',
		crQuery:'',
		user_type:'individual',
      },
	requests:[],
	more_pages:false,
	page:1,
	timeOutId: null,
	orgRequestFilter:{
		year:'',
		month:'',
		query:'',
		crQuery:'',
		user_type:'organization',
	},
	orgRequests:[],
	org_more_pages:false,
	orgPage:1,
	orgTimeOutId: null
};


const secretarySlice = createSlice({
	name: 'secretary',
	initialState,
	reducers: {
		setRequestFilter: (state,action) => {
			state.requestFilter = action.payload;
		},
		setRequests: (state,action) => {
			state.requests = action.payload.requests_list;
			state.more_pages = action.payload.more_pages;
			state.page = 1;
		},
		setMoreRequests: (state,action) => {
			console.log('the new set of requests',action.payload.requests_list)
			state.requests.push(...action.payload.requests_list);
			state.more_pages = action.payload.more_pages;
		},
		setPage: (state,action) => {
			state.page = action.payload;
		},
		setTimeOutId: (state,action) => {
			state.timeOutId = action.payload;
		},
		clearSecretaryRequestsCache: (state,action) => {
			
			console.log('clearSecretaryRequestsCache has started!')
			
			state.requests = [];
			state.requestFilter = {
				year:'',
				month:'',
				query:'',
				crQuery:'',
				user_type:'individual',
			}
			state.more_pages = false;
			state.page = 1;
			
			
		},
		setOrgRequestFilter: (state,action) => {
			state.orgRequestFilter = action.payload;
		},
		setOrgRequests: (state,action) => {
			state.orgRequests = action.payload.requests_list;
			state.org_more_pages = action.payload.more_pages;
			state.orgPage = 1;
		},
		setMoreOrgRequests: (state,action) => {
			console.log('the new set of requests',action.payload.requests_list)
			state.orgRequests.push(...action.payload.requests_list);
			state.org_more_pages = action.payload.more_pages;
		},
		setOrgPage: (state,action) => {
			state.orgPage = action.payload;
		},
		setOrgTimeOutId: (state,action) => {
			state.orgTimeOutId = action.payload;
		},
		clearSecretaryOrgRequestsCache: (state,action) => {
			
			console.log('clearSecretaryRequestsCache has started!')
			
			state.orgRequests = [];
			state.orgRequestFilter = {
				year:'',
				month:'',
				query:'',
				crQuery:'',
				user_type:'organization',
			  }
			state.org_more_pages = false;
			state.orgPage = 1;


		},
	},
});


export const { 
	setRequestFilter,
	setRequests,
	setMoreRequests,
	setPage,
	clearSecretaryRequestsCache,
	setTimeOutId,
	setOrgRequestFilter,
	setOrgRequests,
	setMoreOrgRequests,
	setOrgPage,
	setOrgTimeOutId,
	clearSecretaryOrgRequestsCache,
 } = secretarySlice.actions;
export default secretarySlice.reducer;